(function () {
    function initFaqAccordions() {
        document.querySelectorAll('[data-faq]').forEach(function (faq) {
            const triggers = faq.querySelectorAll('[data-faq-trigger]');

            triggers.forEach(function (trigger) {
                trigger.addEventListener('click', function () {
                    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
                    const answerId = trigger.getAttribute('aria-controls');
                    const answer = answerId ? document.getElementById(answerId) : null;
                    const item = trigger.closest('.faq__item');
                    const shouldOpen = !isOpen;

                    trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');

                    if (item) {
                        item.classList.toggle('faq__item--open', shouldOpen);
                    }

                    if (answer) {
                        answer.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
                    }
                });
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFaqAccordions);
    } else {
        initFaqAccordions();
    }
})();
